import { useState } from "react"
import { Graph } from "../../components/Tabs/Temp/Graph"
import slidersign from "./slidersign.png"
import { useTranslation } from "react-i18next"

export const CountValueData = () => {
      // language translator
      const { t } = useTranslation("translation")
 const [toggle, setToggle] = useState<boolean>(false)
 const [showGraphChart, setShowGraphChart] = useState(false)
 const [showTableChart, setShowTableChart] = useState(false)

 return (
  <div className="w-[96%] mt-6 mx-auto">
   <div className="flex justify-between items-center">
    <h1 className="font-semibold text-xl">{t("counterValues")}</h1>
    <div
     onClick={() => {
      setToggle((prev) => {
       return !prev
      })
     }}
     className="bg-white h-10 w-10 rounded flex justify-center items-center cursor-pointer"
    >
     <img src={slidersign} alt="slidersignimg" />
    </div>
   </div>
    <Graph
    isOpen={toggle}
    setShowGraphChart={(value) => {
      setShowGraphChart(value)
     }}
     showGraphChart={showGraphChart}
     setShowTableChart={(value) => {
        setShowTableChart(value)
       }}
       showTableChart={showTableChart}
    
    /> 
  </div>
 )
}
